export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN = '/admin';
export const PROJECTS = '/projects';
export const ACTIONS = '/actions';
